module.exports = __webpack_public_path__ + "img/t6-purple.41663749.png";